import React, { FC, ReactNode } from "react";
import Modal from "react-modal";
import { CloseButton } from "../../CloseButton/CloseButton";
import classNames from "classnames";
import { ModalBgColorVariant } from "./ModalBgColorVariant";

interface ModalLayoutProps {
	onClose: () => void;
	isOpen: boolean;
	children: ReactNode;
	bgColorVariant?: ModalBgColorVariant;
	heading?: string;
	className?: string;
}

export const ModalLayout: FC<ModalLayoutProps> = ({
	onClose,
	isOpen,
	bgColorVariant = "white",
	heading,
	children,
	className,
}) => {
	return (
		<Modal
			className={classNames(
				"Modal",
				{ "Modal--opened": isOpen },
				{ "Modal--withoutHeading": !heading },
				{ "Modal--bgWhite": bgColorVariant === "white" },
				{ "Modal--bgBlue": bgColorVariant === "blue" },
				className
			)}
			overlayClassName="ModalOverlay"
			isOpen={isOpen}
			shouldCloseOnEsc
			onRequestClose={onClose}
		>
			<CloseButton onClick={onClose} className="Modal__closeButton" />
			{heading && <h4 className="Modal__heading">{heading}</h4>}
			<div className="Modal__mainContent">{children}</div>
		</Modal>
	);
};
